import { api } from './http-client';
import { AiSettings, LlmUsageLogsResponse } from '../interfaces/ai.interface';

export const aiService = {
  getSettings: async (): Promise<AiSettings> => {
    const response = await api.request<AiSettings>({
      url: '/admin/ai/settings',
      method: 'GET',
    });
    return response.data;
  },

  updateSettings: async (settings: AiSettings): Promise<AiSettings> => {
    const response = await api.request<AiSettings>({
      url: '/admin/ai/settings',
      method: 'PUT',
      data: settings,
    });
    return response.data;
  },

  getLogs: async (params: {
    page?: number;
    limit?: number;
    formType?: string;
    model?: string;
  }): Promise<LlmUsageLogsResponse> => {
    const response = await api.request<LlmUsageLogsResponse>({
      url: '/admin/ai/logs',
      method: 'GET',
      params,
    });
    return response.data;
  },
};
